export enum StatusEnum {
  A = 'Ativo',
  AB = 'Aberto',
  FE = 'Fechado',
  I = 'Inativo',
  S = 'SPC',
  P = 'Pendente',
  E = 'Excluído',
  F = 'Finalizado',
  PG = 'Pago',
  FL = 'Fora de linha',
  W = 'Alerta',
  AT = 'Atrasado',
  C = 'Cancelado',
  PR = 'Parcial',
  AG = 'Agendado',
}
